import {createAction} from '@reduxjs/toolkit'

export const postApiCall = createAction('postApiCall')
export const userApiCall = createAction('userApiCall')
export const commentApiCall = createAction('commentApiCall')